import { useQuery } from '@tanstack/react-query';
import { insightsApi } from '../api/insights';
import { Card } from '../components/Card';
import { CountBars } from '../components/CountBars';
import { KpiCard } from '../components/KpiCard';

export function GrowthScreen() {
  const series = useQuery({ queryKey: ['users-series', 24], queryFn: () => insightsApi.usersSeries(24) });
  const points = series.data ?? [];

  const total = points.reduce((s, p) => s + p.count, 0);
  const premium = points.reduce((s, p) => s + p.premiumCount, 0);
  const last = points[points.length - 1];
  const prev = points[points.length - 2];
  const momDelta =
    last && prev && prev.count > 0 ? ((last.count - prev.count) / prev.count) * 100 : null;

  const bars = points.map((p) => ({ label: p.label, value: p.count, inset: p.premiumCount }));

  return (
    <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 14 }}>
        <KpiCard label="Signups · 24 mo" value={total} accent />
        <KpiCard label="Premium · 24 mo" value={premium} />
        <KpiCard
          label="This month"
          value={last?.count ?? 0}
          delta={momDelta}
          sublabel="vs. last month"
        />
      </div>

      <Card padding={18}>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 16, marginBottom: 12 }}>
          Signups · last 24 months
        </div>
        <CountBars data={bars} height={260} />
      </Card>
    </div>
  );
}
